import React from 'react'
import { useTheme, Box, Typography, Link } from '@mui/material'
import { Spinner } from 'packages/eid-ui'

const CartButton = (props: any) => {
    const { label, icon, onClick, loading, disabled, bgcolor } = props

    const theme = useTheme()

    return (
        <Link
            component="button"
            sx={{
                '&:hover': {
                    cursor: 'pointer',
                },
                ...(disabled && {
                    '&:hover': {
                        cursor: 'default !important',
                    },
                }),
            }}
            underline="none"
            onClick={onClick}
            disabled={disabled}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px',
                    border: 'none',
                    opacity: 1,
                    padding: '10px 16px',
                    ...(disabled && {
                        opacity: 0.7,
                    }),
                }}
                bgcolor={bgcolor}
            >
                <Box display={'flex'} alignItems={'center'} marginRight="8px">
                    {icon}
                </Box>

                <Typography
                    sx={{
                        color: theme?.palette?.common?.white,
                        fontSize: '16px',
                        fontWeight: 'normal',
                    }}
                >
                    {label}
                </Typography>

                {loading && (
                    <Box marginLeft={'8px'}>
                        <Spinner
                            size={0.6}
                            color={theme?.palette?.common?.white}
                        />
                    </Box>
                )}
            </Box>
        </Link>
    )
}

export default CartButton
